import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { enableMaintenanceService } from '../../api/maintenance-service.ts';

export default function useEnableMaintenanceService(): UseMutationResult<
  Awaited<ReturnType<typeof enableMaintenanceService>>,
  Error,
  string
> {
  return useMutation({
    mutationFn: (serviceId: string) => enableMaintenanceService(serviceId),
  });
}
